import { render, staticRenderFns } from "./PostFitOutGuideline.vue?vue&type=template&id=128b7ae1&scoped=true&"
import script from "./PostFitOutGuideline.vue?vue&type=script&lang=js&"
export * from "./PostFitOutGuideline.vue?vue&type=script&lang=js&"
import style0 from "./PostFitOutGuideline.vue?vue&type=style&index=0&id=128b7ae1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128b7ae1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('128b7ae1')) {
      api.createRecord('128b7ae1', component.options)
    } else {
      api.reload('128b7ae1', component.options)
    }
    module.hot.accept("./PostFitOutGuideline.vue?vue&type=template&id=128b7ae1&scoped=true&", function () {
      api.rerender('128b7ae1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tenantProjects/postFitOutLetter/PostFitOutGuideline.vue"
export default component.exports